<template>
    <div class="consultaion">
        <div>
            <div style="padding-bottom:20px;color: #999999;">
                <span class="head_style">当前位置：</span>
                <router-link to="/" class="head_style">首页</router-link> >
                <router-link to="/wenda.html" class="head_style">检索问答</router-link> >
                <span class="head_style">{{title}}</span>
            </div>
            <div class="box-style">
                <h1 class="list_new_title">{{title}}</h1>
                <div style="text-align: center;margin-top:10px">发表时间 ：{{createDate}}</div>
                <div class="list-left" v-html="content">
                    {{content}}
                </div>
            </div>
           <div class="list-left-bottom">
                <span @click="upGuestbookId" v-if="upGuestbook">上一篇：{{upGuestbook.content}}</span>
                <span @click="downGuestbookId" style="text-align:right" v-if="downGuestbook">下一篇：{{downGuestbook.content}}</span>
            </div>
        </div>
        <div class="list-right">
            <div class="list-right-top">
                <div class="list-title">
                    <span style="margin-left:20px">相关推荐</span>
                </div>
                <ul class="list-right-ul">
                    <li v-for="(item,index) in messageList" :key="index" @click="updataRecommend(item.id)"><span>{{item.content}}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    // import merge from 'webpack-merge';
    import {_getValidPage} from '@/api/consultation'
    export default {
        metaInfo() {
            return {
                title: this.title + '|版权服务专家|版权家',
                meta: [{                 // set meta
                    name: 'keyWords',
                    content: '版权服务,版权百科,版权,版权家,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
                }, {
                    name: 'Description',
                    content: '版权信息,版权家,人人都是创作者，人人都是版权人。版权家秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
                }]
            }
        },
        name: "onlineAnswers",
        data() {
            return {
                content: "",
                messageList: [],
                upGuestbook: "",
                downGuestbook: "",
                title: "",
                createDate:""
            }
        },
        methods: {
            //分页查询有效留言
            getValidPage(){
                const value ={
                    pageNumber:1,
                    pageSize:7,
                    sort:"create_date",
                    order:"desc",
                    registerId:"",
                    content:"",
                    phone:""
                }
                _getValidPage(value).then(res => {
                    if(res.code==200){
                        this.messageList = res.result.records
                    }
                });
            },
            getArticles(id) {
                // console.log(this.$route)
                this.getRequest('/cmsGuestbook/get/' + id).then(res => {
                    if (res.code == 200) {
                        console.log(res)
                        this.title = res.result.content;
                        this.content = res.result.reContent;
                        this.createDate = res.result.createDate;
                        this.upGuestbook = res.result.upGuestbook;
                        this.downGuestbook = res.result.downGuestbook;
                    }
                })
            },
            //相关推荐
            updataRecommend(val) {
                this.$router.push({name:'onlineAnswers',params:{id:val}});
            },
            //上一篇
            upGuestbookId() {
                this.getArticles(this.upGuestbook.id)
            },
            //下一篇
            downGuestbookId() {
                this.getArticles(this.downGuestbook.id)
            }
        },
        watch: {
            $route(to, from) {
                console.log('+++++++++++++++++++++', to, from)
                this.getArticles(this.$route.params.id);
            }
        },
        beforeCreate(){
            console.log(this.$route.params.id)
        },
        mounted() {
            this.getArticles(this.$route.params.id);
            this.getValidPage()
        },
    };
</script>

<style scoped lang="less">
    .consultaion {
        width: 1334px;
        display: flex;
        justify-content: space-between;
        margin: 20px auto 50px;
        .head_style{
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 20px;
        }
        .box-style{
            width:890px;
            background:rgba(255,255,255,1);
            box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);
            border-radius:2px;
        }
        .list_new_title {
            width: 830px;
            margin:0 auto;
            text-align: center;
            // line-height: 50px;
            font-size: 28px;
            font-weight: 600;
            color:#333;
            padding-top:50px;
            // box-shadow: 0px 2px 40px 0px rgba(29, 31, 108, 0.04);
            // border-radius: 2px 2px 0px 0px;
            // background: #fff;
            
        }

        .list-left {
            width: 830px;
            min-height: 600px;
            // background: rgba(255, 255, 255, 1);
            // box-shadow: 0px 2px 40px 0px rgba(29, 31, 108, 0.04);
            // border-radius: 0px 0px 2px 2px;
            margin:20px auto;
            /deep/ img {
                max-width: 830px !important;
                margin: 0 auto;
                display: flex;
            }
            // /deep/ p {
            //   font-size: 16px;
            //   color: #666;
            // }
            // /deep/ span {
            //   font-size: 16px;
            //   color: #666;
            // }
        }

        .list-left-bottom {
            width: 890px;
            height: 72px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 2px 40px 0px rgba(29, 31, 108, 0.04);
            border-radius: 2px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            span {
                font-size: 16px;
                color: rgba(102, 102, 102, 1);
                margin: 0px 30px;
                display: inline-block;
                width: 385px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                cursor: pointer;
            }
        }

        .list-right {
            width: 424px;
            height: 835px;

            .list-right-top {
                width: 424px;
                height: 613px;
                background: rgba(255, 255, 255, 1);
                box-shadow: 0px 2px 40px 0px rgba(29, 31, 108, 0.04);
                border-radius: 2px;
                margin-bottom: 20px;

                .list-title {
                    width: 424px;
                    height: 62px;
                    line-height: 62px;
                    background: rgba(255, 255, 255, 1);
                    border-radius: 2px 2px 0px 0px;
                    font-size: 16px;
                    color: rgba(51, 51, 51, 1);
                    border-bottom: 1px solid #EEEEEE;
                }

                .list-right-ul {
                    overflow: hidden;
                    height: 489px;

                    li {
                        list-style: none;
                        height: 60px;
                        width: 404px;
                        line-height: 60px;
                        font-size: 14px;
                        color: rgba(102, 102, 102, 1);
                        margin-left: 20px;
                        border-bottom: 1px solid #EEEEEE;
                        cursor: pointer;

                        span {
                            display: inline-block;
                            width: 394px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                    }
                }
            }
        }
    }
</style>
